/**
 * Duration unit values
 */
export enum DurationUnitEnum {
	HOUR = 'hour',
	DAY = 'day',
	WEEK = 'week',
	MONTH = 'month',
	YEAR = 'year',
}
